// @author jonathan.ronsten@svenskaspel.se

import type { Outcomes } from '../../@types/Board.js';
import type { ITSPayloadBoard } from '../../@types/ITSPayload.js';
import type { SystemType } from '../../@types/SystemType.js';
import { asStringArray } from '../../utils/asStringArray.js';
import BoardPoolgames from './BoardPoolgames.js';

export type ITSSportkryssBoard = ITSPayloadBoard<{
  boardData: Outcomes;
  numSelections: number;
  rowPriceMulti: number;
  systemType: SystemType[];
}>;

class BoardSportkryss extends BoardPoolgames {
  /**
   * Used for tracking and logs.
   *
   * @returns String | String with boardData
   */
  override toString(): string {
    const outcomeString = this.outcomes.map((board) => board.map((selection) => asStringArray(selection))).join(',');

    return `B:[${outcomeString}]`;
  }

  compose(): ITSSportkryssBoard {
    const boardData = this.outcomes
      .join('')
      .split('')
      .map((selection) => Number.parseInt(selection, 10));

    const itsBoard = {
      boardData,
      numSelections: this.outcomes.length,
      rowPriceMulti: 1,
      systemType: [this.systemType],
    };

    type ITSBoardSportkryss = ITSPayloadBoard<typeof itsBoard>;

    return itsBoard as ITSBoardSportkryss;
  }

  composeOwnRows(): ITSPayloadBoard<object> {
    return {} as ITSPayloadBoard<object>;
  }
}

export default BoardSportkryss;
